import styles from "./TelehealthMessageCard.module.css";
import { Box, Button, Card, Typography } from "@mui/material";
import { palette } from "@powerdiary/components-library/lib";

interface ITelehealthMessageCardProps {
    message: string;
    secondaryMessage?: string;
    onRetry?: () => void;
    retryLabel?: string;
    dataTestId: string;
}

const TelehealthMessageCard = ({
    message,
    secondaryMessage,
    onRetry,
    retryLabel,
    dataTestId,
}: Readonly<ITelehealthMessageCardProps>) => {
    return (
        <Card variant="elevation" raised={true} className={styles.messageCard} data-test-id={dataTestId}>
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    textAlign: "center",
                    alignItems: "center",
                }}
            >
                <Typography
                    variant="paragraphExtraLargeRegular"
                    color={palette.neutral["700"]}
                    data-test-id="text_message"
                >
                    {message}
                </Typography>
                {secondaryMessage && (
                    <Typography
                        variant="paragraphExtraLargeRegular"
                        color={palette.neutral["700"]}
                        data-test-id="text_secondary_message"
                    >
                        {secondaryMessage}
                    </Typography>
                )}
                {onRetry && (
                    <Button variant="contained" sx={{ width: "auto" }} data-test-id="button_retry" onClick={onRetry}>
                        {retryLabel ?? "Try again"}
                    </Button>
                )}
            </Box>
        </Card>
    );
};

export default TelehealthMessageCard;
